/* eslint-disable */

'use strict';

import b4w from 'blend4web';

import m_rgba from 'blend4web/src/extern/rgba';

b4w.rgba = m_rgba;

// register the application module
b4w.register('Library3D', function (exports, require) {
    // import modules used by the app
    const m_app = b4w.app;
    const m_anim = b4w.animation;
    const m_cam = b4w.camera;
    const m_cfg = b4w.config;
    const m_cont = b4w.container;
    const m_ctl = b4w.controls;
    const m_data = b4w.data;
    const m_main = b4w.main;
    const m_mat = b4w.material;
    const m_mouse = b4w.mouse;
    const m_obj = b4w.objects;
    const m_preloader = b4w.preloader;
    const m_rgb = b4w.rgb;
    const m_rgba = b4w.rgba;
    const m_scenes = b4w.scenes;
    const m_time = b4w.time;
    const m_trans = b4w.transform;
    const m_vec3 = b4w.vec3;
    const m_tex = b4w.textures;
    const m_ver = b4w.version;
    const m_camera_anim = b4w.camera_anim;

    const PRINT_PREFIX = 'Druck';
    const TEXTURE_SUFFIX = 'Texture';

    const MINE_TIP_PART_NAME = 'Minenspitze';
    const CAP_PART_NAME = 'Kappe_Gruppe';

    const STUDIO_SET_3D_MODEL = 'Studio_Set_v03.json';
    const MATERIAL_LIBRARY_3D_MODEL = 'Schneider_Pen_Material_Library_v05.json';

    const CAMERA_ZOOM_DISTANCE = 9;
    const AUTO_CAMERA = true;

    const SCREENSHOT_WIDTH = 2400;
    const SCREENSHOT_HEIGHT = 600;
    const SCREENSHOT_DISTANCE = 18;


    // detect application mode
    const DEBUG = m_ver.type() === 'DEBUG';


    // automatically detect assets path
    // const APP_ASSETS_PATH = m_cfg.get_assets_path('schneider-pen-configurator');
    const APP_ASSETS_PATH = '/assets/';

    const MATERIAL_TRANSPARENCY_MATRIX = {
        'Transparent_klar': {
            alpha: 0.735,
        },
        'Transparent_klar_fixed': {
            alpha: 0.735,
        },
        'Transparent_klarer_weiß': {
            alpha: 0.5,
        },
        'Transparent_klarer_hell': {
            alpha: 0.3,
        },
    };

    const MATERIAL_COLOR_TRANSPARENCY_MATRIX = {
        // correction of white
        'Transparent_klar_255_255_255': {
            alpha: 0.3,
        },
        'Transparent_klar_fixed_255_255_255': {
            alpha: 0.3,
        },
        'Transparent_klarer_hell_255_255_255': {
            alpha: 0.2,
        },
        'Transparent_blur_255_255_255': {
            alpha: 0.2,
        },
        'Transparent_blur_plus_255_255_255': {
            alpha: 0.2,
        },
    };

    const MATERIAL_PEN_TRANSPARENCY_MATRIX = {
        // 'Transparent_klar_skyton': {
        //     alpha: 0.7,
        // },
    };

    const MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX = {
        'Transparent_klar_255_247_0_skyton': { // yellow
            r: 246,
            g: 226,
            b: 67,
        },
        'Transparent_klar_255_133_13_skyton': { // orange
            r: 255,
            g: 123,
            b: 15,
        },
        'Transparent_klar_219_55_17_skyton': { // red
            r: 207,
            g: 15,
            b: 12,
        },
        'Transparent_klar_236_2_121_skyton': { // magenta
            r: 199,
            g: 5,
            b: 106
        },
        'Transparent_klar_119_0_135_skyton': { // purple
            r: 57,
            g: 25,
            b: 124
        },
        'Transparent_klar_0_127_140_skyton': { // petrol
            r: 1,
            g: 127,
            b: 163
        },
        'Transparent_klar_0_106_184_skyton': { // blue
            r: 0,
            g: 61,
            b: 161
        },
        'Transparent_klar_9_146_0_skyton': { // green
            r: 17,
            g: 117,
            b: 19
        },
        'Transparent_klar_0_0_0_skyton': { // black
            r: 51,
            g: 63,
            b: 78
        },
        'Transparent_klar_fixed_255_247_0_skyton': { // yellow
            r: 246,
            g: 226,
            b: 67,
        },
        'Transparent_klar_fixed_255_133_13_skyton': { // orange
            r: 255,
            g: 123,
            b: 15,
        },
        'Transparent_klar_fixed_219_55_17_skyton': { // red
            r: 207,
            g: 15,
            b: 12,
        },
        'Transparent_klar_fixed_236_2_121_skyton': { // magenta
            r: 199,
            g: 5,
            b: 106
        },
        'Transparent_klar_fixed_119_0_135_skyton': { // purple
            r: 57,
            g: 25,
            b: 124
        },
        'Transparent_klar_fixed_0_127_140_skyton': { // petrol
            r: 1,
            g: 127,
            b: 163
        },
        'Transparent_klar_fixed_0_106_184_skyton': { // blue
            r: 0,
            g: 61,
            b: 161
        },
        'Transparent_klar_fixed_9_146_0_skyton': { // green
            r: 17,
            g: 117,
            b: 19
        },
        'Transparent_klar_fixed_0_0_0_skyton': { // black
            r: 51,
            g: 63,
            b: 78
        },
        'Opak_glanz_188_0_0_evo': {
            r: 220,
            g: 0,
            b: 0,
        },
        'Opak_glanz_188_0_0_evo-pro': {
            r: 220,
            g: 0,
            b: 0,
        },
        'Opak_glanz_0_64_147_k-1': {
            r: 0,
            g: 94,
            b: 177,
        },
        'Transparent_blur_plus_255_255_255_dynamix-pro': {
            alpha: 0.6,
        },
        'Transparent_blur_plus_255_150_0_dynamix-pro': {
            alpha: 0.6,
        },
        'Transparent_blur_plus_219_55_17_dynamix-pro': {
            alpha: 0.6,
        },
        'Transparent_blur_plus_0_106_184_dynamix-pro': {
            alpha: 0.6,
        },
        'Transparent_blur_plus_9_146_0_dynamix-pro': {
            alpha: 0.6,
        },
        'Transparent_blur_plus_0_0_0_dynamix-pro': {
            alpha: 0.6,
        },
        // color 34 - blue - dynamix shine
        'Transparent_klar_0_106_184_dynamix-shine': {
            alpha: 0.3,
        },
        // color 64 - orange - dynamix shine
        'Transparent_klar_255_130_28_dynamix-shine': {
            alpha: 0.3,
        },
        // color 50 - yellow - dynamix shine
        'Transparent_klar_255_247_0_dynamix-shine': {
            alpha: 0.3,
        },
        // color 44 - green - dynamix shine
        'Transparent_klar_9_146_0_dynamix-shine': {
            alpha: 0.3,
        },
        // color 52 - orange - dynamix
        'Transparent_blur_255_150_0_dynamix': {
            alpha: 0.5,
        },
        // color 25 - rot - dynamix recycling
        'Transparent_blur_188_0_0_dynamix-recycling': {
            r: 136,
            g: 6,
            b: 0,
        },
        // color 34 - blau - dynamix recycling
        'Transparent_blur_0_106_184_dynamix-recycling': {
            r: 11,
            g: 54,
            b: 131,
        },
        // color 48 - hellgrün - dynamix recycling
        'Transparent_blur_131_185_90_dynamix-recycling': {
            r: 82,
            g: 122,
            b: 0,
        },
        // color 64 - orange - dynamix recycling
        'Transparent_blur_255_130_28_dynamix-recycling': {
            r: 208,
            g: 90,
            b: 12,
        },
        // color 96 - pink - dynamix recycling
        'Transparent_blur_170_25_141_dynamix-recycling': {
            r: 160,
            g: 50,
            b: 125,
            // r: 155,
            // g: 55,
            // b: 125,
            // alpha: 0.6
        },
        // color 96 - pink - dynamix recycling
        'Opak_halbglanz_170_25_141_dynamix-recycling': {
            r: 210,
            g: 52,
            b: 102,
        },
        // color 34 - blau - dynamix recycling
        'Opak_halbglanz_0_106_184_dynamix-recycling': {
            r: 11,
            g: 54,
            b: 131,
        },
        'Opak_glanz_0_61_139_take-4-promo': { // blue
            r: 0,
            g: 39,
            b: 65
        },
        // color 62 - orange - haptify
        'Transparent_klar_255_133_13_haptify': {
            r: 228,
            g: 105,
            b: 16,
        },
        // color 62 - orange - haptify-promo
        'Transparent_klar_255_133_13_haptify-promo': {
            r: 228,
            g: 105,
            b: 16,
        },
        'Lackiert_140_140_140_evo-pro-778-xb': {
            r: 210,
            g: 210,
            b: 210,
        },
        'Lackiert_140_140_140_evo-pro-774-m': {
            r: 210,
            g: 210,
            b: 210,
        },
    };

    let _penName;
    let _capOn;

    const ANIM_TIME = 2;
    // var _anim_stop = false;
    let _deltaTarget = ANIM_TIME;
    let _camAnim = {};
    let _camRotationAnim = {};
    let _vec3Tmp = new Float32Array(3);

    let _penDataId, _matDataId;

    let _pickedPart = null;

    let _printAreas = {};

    let _partMaterials = {};

    let _loadSuccessCallback, _partSelectionCallback;

    /**
     * Initialize the app
     *
     * @param {string} penName - Name of a pen to load
     * @param {function} loadSuccess_cb - Callback function, which is executed after scene and model are loaded and initialized
     * @param {function} partSelection_cb - Callback function, which is executed after click on a pen part, which is configurable
     */
    exports.init = function (penName, loadSuccess_cb, partSelection_cb) {
        const qualityLevels = {
            LOW: m_cfg.P_LOW,
            HIGH: m_cfg.P_HIGH,
            ULTRA: m_cfg.P_ULTRA,
            AUTO: m_cfg.P_AUTO,
        };
        let qualityLevel = m_cfg.P_ULTRA;
        let showFps = false;

        const url_params = m_app.get_url_params();

        if (url_params && 'quality' in url_params && url_params['quality'] in qualityLevels) {
            qualityLevel = qualityLevels[url_params['quality']];
        }

        if (url_params && 'show_fps' in url_params) {
            showFps = true;
        }

        _penName = penName;
        _capOn = true;
        _loadSuccessCallback = loadSuccess_cb;
        _partSelectionCallback = partSelection_cb;
        m_app.init({
            assets_min50_available: true,
            background_color: [0.0, 0.0, 0.0, 0.0],
            canvas_container_id: 'scene3d',
            callback: init_cb,
            show_fps: showFps,
            console_verbose: DEBUG,
            autoresize: true,
            key_pause_enabled: false,
            quality: qualityLevel,
        });
    };

    /**
     * Unset the complete scene and free the resources
     */
    exports.unset = function () {
        _partMaterials = {};
        m_main.reset();
        m_ctl.remove_sensor_manifold(m_scenes.get_active_camera(), 'CAMERA_MOVE');
        // m_ctl.reset();
    };

    /**
     * Makes horizontal screenshots of a pen from 4 sides
     *
     * @return {Promise} - Promise that will return an array of screenshots on resolve
     */
    exports.getPenShots = function () {
        // set background color to white with full transparency for better screenshot quality
        m_cfg.set('background_color', [0.935, 0.935, 0.935, 0.0]);
        m_cont.resize(SCREENSHOT_WIDTH, SCREENSHOT_HEIGHT);

        const cameraPositions = [
            [0, 0, SCREENSHOT_DISTANCE],
            [0, 0, SCREENSHOT_DISTANCE],
            [0, SCREENSHOT_DISTANCE, 0],
            [0, 0, -SCREENSHOT_DISTANCE],
            [0, -SCREENSHOT_DISTANCE, 0],
            [0, 0, SCREENSHOT_DISTANCE],
        ];

        if (exports.hasCap()) {
            // add a new camera position for a pen without cap
            cameraPositions.push([0, 0, SCREENSHOT_DISTANCE]);

            if (!_capOn) {
                exports.toggleCap(true);
            }
        }

        return makeShots(cameraPositions);
    };

    function take_shot(currentPosition, positions) {
        return new Promise((resolve, reject) => {
            const position = positions[currentPosition];
            const camera = m_scenes.get_active_camera();
            const cameraPivot = Float32Array.from([0, 0, 0]);

            // if a pen has a cap and this is the last screenshot to be taken
            if (exports.hasCap() && currentPosition === positions.length - 1) {
                // it should be taken without a cap and cap should not be visible
                m_scenes.hide_object(m_scenes.get_object_by_name(CAP_PART_NAME, _penDataId));
            }

            m_cam.target_set_trans_pivot(
                camera,
                position,
                cameraPivot,
            );

            pointPenTipLeft(camera, position, false);

            setTimeout(() => {
                let d = new Date();
                console.log(d.getTime());
                m_main.canvas_data_url(function (url) {
                    resolve(url);
                }, 'image/jpeg');
            }, 1);
        });
    }

    function makeShots(camera_positions) {
        return new Promise((resolve, reject) => {
            let screenshots = [];

            function run(currentPosition) {
                take_shot(currentPosition, camera_positions).then((url) => {
                    screenshots.push(url);
                    if (currentPosition < camera_positions.length - 1) {
                        run(currentPosition + 1);
                    } else {
                        screenshots.shift();
                        resolve(screenshots);
                    }
                });
            }

            return run(0);
        });
    }

    /**
     * Returns the names of detected print areas in a 3D model
     *
     * @returns {Array}
     * @deprecated Print area names are taken from BE Configuration
     */
    exports.getPrintAreas = function () {
        const selectableObjects = m_obj.get_selectable_objects();
        let printAreas = [];
        for (let selectableObject of selectableObjects) {
            let objectName = m_scenes.get_object_name(selectableObject);
            if (objectName.startsWith(PRINT_PREFIX)) {
                printAreas.push(objectName);
            }
        }

        return printAreas;
    };

    /**
     * Returns an object of CanvasRenderingContext2D type, which is used as print area texture
     *
     * @param {string} printAreaName
     * @return {CanvasRenderingContext2D}
     */
    exports.getCanvasContext = function (printAreaName) {
        const printArea = m_scenes.get_object_by_name(printAreaName, _penDataId);
        const printAreaTextureName = printAreaName + '_' + TEXTURE_SUFFIX;

        return m_tex.get_canvas_ctx(printArea, printAreaTextureName);
    };

    /**
     * Sets the CanvasRenderingContext2D for provided print area and updates the texture on 3D model
     *
     * @param {string} printAreaName
     * @param {CanvasRenderingContext2D} canvasContext @deprecated
     */
    exports.setCanvasContext = function (printAreaName, canvasContext) {
        const printArea = m_scenes.get_object_by_name(printAreaName, _penDataId);
        const printAreaTextureName = printAreaName + '_' + TEXTURE_SUFFIX;

        m_tex.update_canvas_ctx(printArea, printAreaTextureName);
    };

    /**
     * Returns the name of current active ('picked') object
     *
     * @return {string}
     */
    exports.getPickedPart = function () {
        if (_pickedPart) {
            return m_scenes.get_object_name(_pickedPart);
        } else {
            return '';
        }
    };

    /**
     * Sets the active ('picked') object by name
     *
     * @param {string} partName
     */
    exports.setPickedPart = function (partName) {
        _pickedPart = m_scenes.get_object_by_name(partName, _penDataId);
        if (m_scenes.outlining_is_enabled(_pickedPart)) {
            m_scenes.apply_outline_anim(_pickedPart, 2, 2, 1);
        }
    };

    /**
     * Returns complete 3D configuration of an object
     *
     * @returns {Object}
     */
    // exports.getConfiguration = function () {
    //
    // };

    /**
     * Accepts the complete configuration and applies it on 3D model
     *
     * @param {Object} configuration
     * @see Configurator.jsx for configuration format
     */
    exports.setConfiguration = function (configuration) {
        // iterate through configurable parts
        const parts = Object.keys(configuration.parts);
        for (let part of parts) {
            const partConfig = configuration.parts[part];
            exports.setMaterial(part, partConfig.material);
            exports.setColor(part, partConfig.color);
        }

        // set color of mine tip, if its a colorful
        if (exports.isMineTipColorful()) {
            const partName = exports.getMineTipPartName();
            exports.setColor(partName, configuration.mine_color);
        }

        // Strange fix for transparent Cap on transparent Pen
        // The Cap should be set at last to make it possible to see transparent pen behind the cap
        const capName = 'Kappe';
        if (capName in configuration.parts) {
            exports.setMaterial(capName, configuration.parts[capName].material);
            exports.setColor(capName, configuration.parts[capName].color);
        }

        // TODO: add handling of print areas
    };

    /**
     * Sets the material for corresponding part
     *
     * @param {string} partName
     * @param {string} materialName
     */
    exports.setMaterial = function (partName, materialName) {
        const objectPart = m_scenes.get_object_by_name(partName, _penDataId);
        const materialObject = m_scenes.get_object_by_name(materialName, _matDataId);
        //set_specular_intensity();

        m_mat.inherit_material(
            materialObject,
            materialName,
            objectPart,
            m_mat.get_materials_names(objectPart)[0],
        );

        _partMaterials[partName] = materialName;
    };

    /**
     * Sets the color of corresponding part
     *
     * @param {string} partName
     * @param {Object} color - Object with keys 'r', 'g', 'b'
     */
    exports.setColor = function (partName, color) {
        let newColor = {...color};

        const objectPart = m_scenes.get_object_by_name(partName, _penDataId);

        m_mat.get_materials_names(objectPart).forEach(function (objectsMaterial) {

            let materialName = _partMaterials[partName];
            console.log('set color ', partName);

            if (m_mat.is_node_material(objectPart, objectsMaterial)) {
                let alphaChannel = getAlphaForMaterialAndColor(materialName, newColor, _penName);
                if (alphaChannel != null) {
                    m_mat.set_nodemat_value(objectPart, [objectsMaterial, 'AlphaFactor'], alphaChannel);
                }

                newColor = getColorForSpecificPenAndMaterial(materialName, newColor, _penName);

                if (
                    materialName === 'Lackiert' &&
                    newColor.r === 0 &&
                    newColor.g === 0 &&
                    newColor.b === 0
                ) {
                    m_mat.set_nodemat_value(objectPart, [objectsMaterial, 'DiffuseFactor'], 0.4);
                }

                if (
                    (materialName === 'Transparent_blur' || materialName === 'Transparent_blur_plus') &&
                    newColor.r === 255 &&
                    newColor.g === 255 &&
                    newColor.b === 255
                ) {
                    newColor.r = 200;
                    newColor.g = 200;
                    newColor.b = 200;
                }

                if (
                    (materialName === 'Transparent_blur' || materialName === 'Transparent_blur_plus') &&
                    newColor.r === 0 &&
                    newColor.g === 0 &&
                    newColor.b === 0
                ) {
                    newColor.r = 60;
                    newColor.g = 60;
                    newColor.b = 60;
                }

                const colorRGB = m_rgb.css_to_rgb(newColor.r, newColor.g, newColor.b);
                m_mat.set_nodemat_rgb(
                    objectPart,
                    [objectsMaterial, 'RGB'],
                    colorRGB[0],
                    colorRGB[1],
                    colorRGB[2],
                );

            } else {
                let alphaChannel = m_mat.get_diffuse_color(objectPart, objectsMaterial)[3];
                alphaChannel = getAlphaForMaterialAndColor(materialName, newColor, _penName, alphaChannel);
                newColor = getColorForSpecificPenAndMaterial(materialName, newColor, _penName);

                if (
                    (materialName === 'Transparent_klar' || materialName === 'Transparent_klar_fixed' || materialName === 'Transparent_klarer_hell') &&
                    newColor.r === 0 &&
                    newColor.g === 0 &&
                    newColor.b === 0
                ) {
                    newColor.r = 60;
                    newColor.g = 60;
                    newColor.b = 60;
                }

                if (
                    (materialName === 'Transparent_klar' || materialName === 'Transparent_klar_fixed' || materialName === 'Transparent_klarer_hell') &&
                    newColor.r === 255 &&
                    newColor.g === 255 &&
                    newColor.b === 255
                ) {
                    newColor.r = 200;
                    newColor.g = 200;
                    newColor.b = 200;
                    m_mat.set_diffuse_color_factor(objectPart, objectsMaterial, 0.3);
                }

                if (
                    materialName === 'Gummi' && _penName != 'like' &&
                    newColor.r === 255 &&
                    newColor.g === 255 &&
                    newColor.b === 255
                ) {
                    newColor.r = 200;
                    newColor.g = 200;
                    newColor.b = 200;
                }

                //m_mat.set_diffuse_intensity(objectPart, objectsMaterial, 0.5);

                if (_penName == 'slider-xite-promo') {
                    m_mat.set_diffuse_color_factor(objectPart, objectsMaterial, 0);
                }


                m_mat.set_diffuse_color(
                    objectPart,
                    objectsMaterial,
                    m_rgba.css_to_rgba(newColor.r, newColor.g, newColor.b, alphaChannel),
                );
            }
        });

        // Check for dependant parts
        if (m_scenes.check_object_by_name(partName + '_2', _penDataId)) {
            exports.setColor(partName + '_2', color);
        }
    };

    /**
     * Get the color of a parent part
     * Used mainly for print areas only
     *
     * @param partName
     * @return {{r: *, g: *, b: *}}
     */
    exports.getParentColor = function (partName) {
        const objectParent = m_obj.get_parent(m_scenes.get_object_by_name(partName, _penDataId));
        const parentsMaterial = m_mat.get_materials_names(objectParent)[0];

        // if object not selectable, it can have an unknown material, so falling back to white
        if (!objectParent.render.selectable) {
            return {
                r: 255,
                g: 255,
                b: 255,
            };
        }

        let colorRGB;
        if (m_mat.is_node_material(objectParent, parentsMaterial)) {
            colorRGB = m_rgb.rgb_to_css(
                m_mat.get_nodemat_rgb(objectParent, [parentsMaterial, 'RGB']),
            );
        } else {
            colorRGB = m_rgba.rgba_to_css(m_mat.get_diffuse_color(objectParent, parentsMaterial));
        }

        return {
            r: colorRGB[0],
            g: colorRGB[1],
            b: colorRGB[2],
        };
    };

    /**
     * Animates and moves camera from current point and pivot to a position in front of provided object, using it as pivot
     *
     * @param objectName
     */
    exports.focusCameraOn = function (objectName) {
        let objectPrefix = objectName;
        if (objectName.startsWith(PRINT_PREFIX)) {
            objectPrefix = getPrintAreaShortName(objectName);
        }

        const camera = m_scenes.get_active_camera();

        // check whether the camera position point and pivot exists
        const targetName = objectPrefix + '_target';
        const eyeName = objectPrefix + '_eye';
        if (
            m_scenes.check_object_by_name(eyeName, _penDataId) &&
            m_scenes.check_object_by_name(targetName, _penDataId)
        ) {
            const target = m_scenes.get_object_by_name(targetName, _penDataId);
            const eye = m_scenes.get_object_by_name(eyeName, _penDataId);
            const posView = m_trans.get_translation(eye);
            const posTarget = m_trans.get_translation(target);

            // _camAnim.final_rotation = m_trans.get_rotation_euler(eye)[2];

            startCameraAnimation(camera, posView, posTarget, function () {
                // const printObj = m_scenes.get_object_by_name(objectName, _penDataId);
                exports.setPickedPart(objectName);
            });

            // start_camera_animation(camera, posView, posTarget);

            // console.log(m_cam.get_translation(camera));
        } else {
            const target = m_scenes.get_object_by_name(objectName, _penDataId);
            const center = m_trans.get_object_center(target, false);

            // if y and z coordinates of center are on x-axis, means that a part is around of a pen tube and coordinates can be faked
            if (center[1] === 0 && center[2] === 0) {
                // TODO: any more intelligent determnition?
                center[1] = 1;
                center[2] = 1;
            }

            // create from found center a vector, which has only x-coordinate
            let xPositionCenter = new Float32Array(3);
            m_vec3.copy(center, xPositionCenter);
            xPositionCenter[1] = 0;
            xPositionCenter[2] = 0;

            // find a vector which points from y:0, z:0 to a center of a selected part
            let positionVector = new Float32Array(3);
            m_vec3.subtract(center, xPositionCenter, positionVector);

            // normalize vector to apply a correct scale
            let normalizedPositionVector = new Float32Array(3);
            m_vec3.normalize(positionVector, normalizedPositionVector);
            //console.log('normalizedPositionVector', normalizedPositionVector);

            // scale it to a zoom distance
            let cameraPosition = new Float32Array(3);
            m_vec3.scale(normalizedPositionVector, CAMERA_ZOOM_DISTANCE, cameraPosition);

            // TODO: find out, why this makes strange transition between some points
            cameraPosition[0] = xPositionCenter[0];

            if (_penName === 'slider-xite-promo') {
                m_cam.target_set_trans_pivot(camera, cameraPosition, center);
                pointPenTipLeft(camera, cameraPosition, false);
            }

            console.log('target', target);
            console.log('cameraPosition', cameraPosition);
            console.log('center', center);
            console.log('xPositionCenter', xPositionCenter);
            console.log('positionVector', positionVector);
            console.log('normalizedPositionVector', normalizedPositionVector);
            console.log('camera', camera);

            startCameraAnimation(camera, cameraPosition, center, function () {
                exports.setPickedPart(objectName);
            });
        }
    };

    function pointPenTipLeft(camera, positionVector, animate, animationFinishedCallback) {
        let cameraAngles = m_cam.get_camera_angles(camera);
        let phi = cameraAngles[0];
        let theta = cameraAngles[1];

        // console.log(cameraAngles);

        if (!animate) {
            let angle = m_vec3.angle([0, 0, 1], positionVector);

            if (positionVector[1] > 0) {
                angle = angle * -1;
            }

            m_cam.rotate_camera(camera, 0, angle, true);
        }
    }

    /**
     * Checks if a pen's mine tip can change it's color
     *
     * @return bool
     */
    exports.isMineTipColorful = function () {
        return m_scenes.check_object_by_name(MINE_TIP_PART_NAME, _penDataId);
    };

    /**
     * Return a mine tip part name, used in references
     *
     * @return string
     */
    exports.getMineTipPartName = function () {
        return MINE_TIP_PART_NAME;
    };

    /**
     * Checks if a pen has cap
     *
     * @return bool
     */
    exports.hasCap = function () {
        return m_scenes.check_object_by_name(CAP_PART_NAME, _penDataId);
    };

    /**
     * Toggles the cap of a pen
     *
     * @param {boolean} fast - should the cap be toggled without a lang animation
     */
    exports.toggleCap = function (fast) {
        const kappe = m_scenes.get_object_by_name(CAP_PART_NAME, _penDataId);
        let capAction = _capOn ? 'CapActionOff' : 'CapActionOn';
        m_anim.apply(kappe, capAction);
        m_anim.set_behavior(kappe, m_anim.AB_FINISH_STOP);
        if (fast) {
            m_anim.set_last_frame(kappe);
        } else {
            m_anim.play(kappe);
        }
        _capOn = !_capOn;
    };

    /**
     * Resets camera to it's initial position and pivot
     */
    exports.resetCamera = function () {
        const camobj = m_scenes.get_active_camera();
        _camAnim.final_rotation = 0;

        // TODO: read these values from Scene File
        // const camera_pos = new Float32Array(3);
        // camera_pos[0] = -3.88526;
        // camera_pos[1] = -2.58519;
        // camera_pos[2] = 22.3404;

        const camera_pos = new Float32Array(3);
        camera_pos[0] = -3.88526;
        camera_pos[1] = -22.3404;
        camera_pos[2] = -2.58519;

        const target_pos = new Float32Array(3);
        target_pos[0] = 0.0;
        target_pos[1] = 0.0;
        target_pos[2] = 0.0;

        startCameraAnimation(camobj, camera_pos, target_pos, function () {
            // const printObj = m_scenes.get_object_by_name(objectName, _penDataId);
            // exports.setPickedPart(objectName);
        });

        // start_camera_animation(camobj, camera_pos, target_pos);
    };

    /**
     * Callback executed when the app is initialized
     */
    function init_cb(canvasElem, success) {
        if (!success) {
            console.log('b4w init failure');
            return;
        }

        m_preloader.create_preloader();

        // ignore right-click on the canvas element
        canvasElem.oncontextmenu = function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        };

        load();
    }

    /**
     * load the scene data
     */
    function load() {
        m_data.load(APP_ASSETS_PATH + STUDIO_SET_3D_MODEL, sceneLoad_cb);
    }

    function sceneLoad_cb(data_id, success) {
        // const camera = m_scenes.get_active_camera();
        //
        // let upAxis = new Float32Array(3);
        // upAxis[0] = 0.0;
        // upAxis[1] = 1.0;
        // upAxis[2] = 0.0;
        // m_cam.set_vertical_axis(camera, upAxis);

        _matDataId = m_data.load(
            APP_ASSETS_PATH + MATERIAL_LIBRARY_3D_MODEL,
            null,
            null,
            false,
            true,
        );
        _penDataId = m_data.load(APP_ASSETS_PATH + _penName + '.json', load_cb, preloader_cb);
    }

    /**
     * update the app's preloader
     */
    function preloader_cb(percentage) {
        m_preloader.update_preloader(percentage);
    }

    /**
     * callback executed when the scene data is loaded
     */
    function load_cb(dataId, success) {
        if (!success) {
            console.log('b4w load failure');
            return;
        }

        // console.log(APP_ASSETS_PATH);

        // _penDataId = data_id;
        // console.log(m_cfg.get("canvas_resolution_factor"));
        // m_cfg.set("canvas_resolution_factor", 2);
        // console.log(m_cfg.get("canvas_resolution_factor"));

        m_app.enable_camera_controls(false, true);
        const camObj = m_scenes.get_active_camera();
        const initialTranslation = m_cam.get_translation(camObj);

        const upAxis = new Float32Array(3);
        upAxis[0] = 0.0;
        upAxis[1] = 1.0;
        upAxis[2] = 0.0;
        m_cam.set_vertical_axis(camObj, upAxis);

        const resultingTranslation = new Float32Array(3);
        m_vec3.copy(initialTranslation, resultingTranslation);
        resultingTranslation[1] = -initialTranslation[2];
        resultingTranslation[2] = initialTranslation[1];
        m_cam.target_set_trans_pivot(camObj, resultingTranslation);

        initCameraAnimation(camObj);

        const container = m_cont.get_canvas();
        container.addEventListener('mouseup', mainCanvasClicked_cb, false);

        // TODO: fire 'loaded' event ?
        _loadSuccessCallback();
    }

    function mainCanvasClicked_cb(e) {
        const x = m_mouse.get_coords_x(e);
        const y = m_mouse.get_coords_y(e);

        const objectPart = m_scenes.pick_object(x, y);
        if (objectPart) {
            exports.setPickedPart(m_scenes.get_object_name(objectPart));
            _partSelectionCallback();
        }
    }

    /**
     * Transforms Druck_D2_240_345_943_190 to Druck_D2
     *
     * @param printAreaLongName
     * @return {string}
     * @deprecated Print areas have always short names in 3d File
     */
    function getPrintAreaShortName(printAreaLongName) {
        const tmpPrintAreaNameParts = printAreaLongName.split('_');
        return tmpPrintAreaNameParts[0] + '_' + tmpPrintAreaNameParts[1];
    }

    /**
     * Returns modified alpha channel value depending on material and/or color
     *
     * @param materialName string
     * @param color {Object} Object with keys 'r', 'g', 'b'
     * @param penName string
     * @param baseAlpha number|null
     * @returns number
     */
    function getAlphaForMaterialAndColor(materialName, color, penName, baseAlpha = null) {

        console.log(penName);
        console.log('alpha for material ' + materialName + ': ' + baseAlpha);

        if (MATERIAL_TRANSPARENCY_MATRIX.hasOwnProperty(materialName)
            && MATERIAL_TRANSPARENCY_MATRIX[materialName].hasOwnProperty('alpha')) {
            baseAlpha = MATERIAL_TRANSPARENCY_MATRIX[materialName].alpha;
            console.log('alpha for material ' + materialName + ' (after material adjustment): ' + baseAlpha);
        }


        let concatMaterialColor = getMaterialColorIdentifier(materialName, color);
        console.log(concatMaterialColor);
        if (MATERIAL_COLOR_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialColor)
            && MATERIAL_COLOR_TRANSPARENCY_MATRIX[concatMaterialColor].hasOwnProperty('alpha')) {
            baseAlpha = MATERIAL_COLOR_TRANSPARENCY_MATRIX[concatMaterialColor].alpha;
        }

        console.log('alpha for material ' + materialName + ' (after color adjustment): ' + baseAlpha);

        let concatMaterialPen = getMaterialPenIdentifier(materialName, penName);
        console.log(concatMaterialPen);
        if (MATERIAL_PEN_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialPen)
            && MATERIAL_PEN_TRANSPARENCY_MATRIX[concatMaterialPen].hasOwnProperty('alpha')) {
            baseAlpha = MATERIAL_PEN_TRANSPARENCY_MATRIX[concatMaterialPen].alpha;
        }

        console.log('alpha for material ' + materialName + ' (after pen material adjustment): ' + baseAlpha);

        let concatMaterialColorPen = getMaterialColorPenIdentifier(materialName, color, penName);
        console.log(concatMaterialColorPen);
        if (MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialColorPen)
            && MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].hasOwnProperty('alpha')) {
            baseAlpha = MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].alpha;
        }

        console.log('alpha for material ' + materialName + ' (after pen color adjustment): ' + baseAlpha);

        return baseAlpha;
    }

    /**
     * Returns modified color value depending on material and/or pen
     *
     * @param materialName string
     * @param newColor {Object} Object with keys 'r', 'g', 'b'
     * @param penName string
     * @returns object
     */
    function getColorForSpecificPenAndMaterial(materialName, newColor, penName) {

        let concatMaterialColorPen = getMaterialColorPenIdentifier(materialName, newColor, penName);

        console.log('color before changes (base): ' + getMaterialColorPenIdentifier(materialName, newColor, penName));

        if (MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialColorPen)
            && MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].hasOwnProperty('r')) {
            newColor.r = MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].r;
        }
        if (MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialColorPen)
            && MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].hasOwnProperty('g')) {
            newColor.g = MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].g;
        }
        if (MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX.hasOwnProperty(concatMaterialColorPen)
            && MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].hasOwnProperty('b')) {
            newColor.b = MATERIAL_COLOR_PEN_TRANSPARENCY_MATRIX[concatMaterialColorPen].b;
        }

        console.log('color after changes: ' + getMaterialColorPenIdentifier(materialName, newColor, penName));

        return newColor;
    }

    function startCameraAnimation(camobj, pos_view, pos_target, finish_cb) {
        console.log('startCameraAnimation camobj', camobj);
        console.log('startCameraAnimation pos_view', pos_view);
        console.log('startCameraAnimation pos_target', pos_target);

        // retrieve camera current position
        m_cam.target_get_pivot(camobj, _camAnim.current_target);
        m_trans.get_translation(camobj, _camAnim.current_eye);

        // set camera starting position
        m_vec3.copy(_camAnim.current_target, _camAnim.starting_target);
        m_vec3.copy(_camAnim.current_eye, _camAnim.starting_eye);

        // set camera final position
        m_vec3.copy(pos_view, _camAnim.final_eye);
        m_vec3.copy(pos_target, _camAnim.final_target);

        _camAnim.finish_cb = finish_cb;

        // start animation
        _deltaTarget = ANIM_TIME;
        _camAnim.timeline = m_time.get_timeline();

        m_cam.target_set_distance_limits(camobj, null);
        m_cam.target_set_horizontal_limits(camobj, null);
        m_cam.target_set_vertical_limits(camobj, null);
    }

    function initCameraAnimation(camobj) {
        const t_sensor = m_ctl.create_timeline_sensor();
        const e_sensor = m_ctl.create_elapsed_sensor();

        _camAnim = {
            timeline: -ANIM_TIME,
            starting_eye: new Float32Array(3),
            starting_target: new Float32Array(3),
            final_eye: new Float32Array(3),
            final_target: new Float32Array(3),
            final_rotation: 0,
            current_eye: new Float32Array(3),
            current_target: new Float32Array(3),
            finish_cb: function () {
            },
        };

        const logic_func = function (s) {
            // s[0] = m_time.get_timeline() (t_sensor value)
            return s[0] - _camAnim.timeline < ANIM_TIME;
        };

        const cam_move_cb = function (camobj, id, pulse) {
            if (pulse === 1) {
                m_app.disable_camera_controls();

                // elapsed = frame time (e_sensor value)
                let elapsed = m_ctl.get_sensor_value(camobj, id, 1);
                let delta = elapsed / ANIM_TIME;

                m_vec3.subtract(_camAnim.final_eye, _camAnim.starting_eye, _vec3Tmp);
                m_vec3.scaleAndAdd(_camAnim.current_eye, _vec3Tmp, delta, _camAnim.current_eye);

                _deltaTarget -= elapsed;
                delta = 1 - (_deltaTarget * _deltaTarget) / (ANIM_TIME * ANIM_TIME);
                m_vec3.subtract(_camAnim.final_target, _camAnim.starting_target, _vec3Tmp);
                m_vec3.scaleAndAdd(
                    _camAnim.starting_target,
                    _vec3Tmp,
                    delta,
                    _camAnim.current_target,
                );

                m_cam.target_set_trans_pivot(camobj, _camAnim.current_eye, _camAnim.current_target);

                // m_cam.rotate_camera(camera, 0.00001, m_cam.get_camera_angles(camera)[1], true)
                // TODO: calculate rotation steps
                // m_cam.rotate_camera(camobj, 1.4 * delta, 0);

                // console.log('angles before', m_cam.get_camera_angles(camobj));
                // let rotationAzimuthDelta = m_cam.get_camera_angles(camobj)[0] - 0.00001;
                // m_cam.rotate_camera(camobj, rotationAzimuthDelta * delta);
                // console.log('angles after', m_cam.get_camera_angles(camobj));
            } else {
                m_app.enable_camera_controls(false, true);
                m_cam.target_set_trans_pivot(camobj, _camAnim.final_eye, _camAnim.final_target);
                //console.log('final pivot', m_cam.target_get_pivot(camobj));
                //console.log('BEFORE: final angles', m_cam.get_camera_angles(camobj));
                //m_cam.rotate_camera(camobj, 0, -Math.PI);
                //console.log('AFTER: final angles', m_cam.get_camera_angles(camobj));

                // m_cam.rotate_camera(camobj, _camAnim.final_rotation, _camAnim.final_rotation_elevation, true);
                // m_cam.rotate_camera(camobj, _camAnim.final_rotation);
                // TODO: calculate final rotation
                // m_cam.rotate_camera(camobj, 1.4);

                const TARGET_DIST_LIMITS = {min: 7, max: 26};
                //var TARGET_HORIZ_LIMITS = { left: -Math.PI/4, right: Math.PI/4 };
                const TARGET_VERT_LIMITS = {down: -Math.PI / 4, up: Math.PI / 4};
                m_cam.target_set_distance_limits(camobj, TARGET_DIST_LIMITS);
                //m_cam.target_set_horizontal_limits(camobj, TARGET_HORIZ_LIMITS);
                // m_cam.target_set_vertical_limits(camobj, TARGET_VERT_LIMITS);

                _camAnim.finish_cb();
            }
        };

        m_ctl.create_sensor_manifold(
            camobj,
            'CAMERA_MOVE',
            m_ctl.CT_CONTINUOUS,
            [t_sensor, e_sensor],
            logic_func,
            cam_move_cb,
        );
    }

    function getMaterialColorIdentifier(materialName, color) {
        return materialName + '_' + color.r + '_' + color.g + '_' + color.b;
    }

    function getMaterialPenIdentifier(materialName, penName) {
        return materialName + '_' + penName;
    }

    function getMaterialColorPenIdentifier(materialName, color, penName) {
        return materialName + '_' + color.r + '_' + color.g + '_' + color.b + '_' + penName;
    }
});
